import { render, staticRenderFns } from "./LastSeenWell.vue?vue&type=template&id=58853734&"
import script from "./LastSeenWell.vue?vue&type=script&lang=ts&"
export * from "./LastSeenWell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58853734')) {
      api.createRecord('58853734', component.options)
    } else {
      api.reload('58853734', component.options)
    }
    module.hot.accept("./LastSeenWell.vue?vue&type=template&id=58853734&", function () {
      api.rerender('58853734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/admission/LastSeenWell.vue"
export default component.exports